export const mentionSign = "@";
export const mentionRegExp = new RegExp(`(\\s|^)${mentionSign}(\\s|$)`);
export const hasMention = (msg: string) => mentionRegExp.test(msg);
export const isMentionPart = (str: string) => str[0] === mentionSign;
export const getMention = (userName: string) => `${mentionSign}${userName}`;
export const getMentionReplace = (userName: string) =>
  ` ${getMention(userName)} `;
